var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.342,
    height: 27.34,
    viewBox: "0 0 27.342 27.34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    transform: "translate(-42.166 -94.168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 11.962,
    height: 11.962,
    rx: 1.5,
    transform: "translate(42.167 94.167)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M54.546,122.151a1.984,1.984,0,0,1,1.984-1.984h7.993a1.984,1.984,0,0,1,1.984,1.984v7.992a1.984,1.984,0,0,1-1.984,1.984H56.531a1.984,1.984,0,0,1-1.984-1.984Zm-15.38,15.38a1.984,1.984,0,0,1,1.984-1.984h7.993a1.984,1.984,0,0,1,1.984,1.984v7.992a1.984,1.984,0,0,1-1.984,1.984H41.151a1.984,1.984,0,0,1-1.984-1.984Zm17.364-1.984a1.984,1.984,0,0,0-1.984,1.984v7.992a1.984,1.984,0,0,0,1.984,1.984h7.993a1.984,1.984,0,0,0,1.984-1.984v-7.992a1.984,1.984,0,0,0-1.984-1.984Z",
    transform: "translate(3 -26)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.99c8e3d9.svg";
export { ForwardRef as ReactComponent };